import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BicButtonComponent, BicPopupComponent} from "@buildinginformationcloud/bic-ui-components";
import {faUser} from '@fortawesome/pro-solid-svg-icons';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  styleUrls: ['./view-image.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BicPopupComponent, BicButtonComponent, FaIconComponent
  ]
})
export class ViewImageComponent implements OnInit{
  data = inject<{
    image: string;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ViewImageComponent>>(MatDialogRef);
  faUser = faUser;


  image!: string

  ngOnInit() {
    this.image = this.data.image
  }

  close() {
    this.dialogRef.close('close');
  }

  removeImage(){
    this.dialogRef.close('remove');
  }

  uploadImage(){
    this.dialogRef.close('upload');
  }

  isDefaultImage(image: string | undefined): boolean {
    const normalizedImage = image?.trim();
    return !normalizedImage
      || normalizedImage === 'null'
      || normalizedImage === 'undefined'
      || normalizedImage.includes('defaultImages/');
  }

}
